enum Step {
    SendCode = 1,
    SetPassword = 2,
    Success = 3,
    Redirect = 4
}

export default Step;
